import React from "react";

import { Link } from "react-router-dom";

import { Tag } from "antd";
import Moment from "moment";
import { DATE_FORMAT } from "../../../../core/utils/i18n-js";
import { AmountText } from "../../../../core/components/widget/amountInline";

import { LAYOUT_MANAGER_JOB_SHOW } from "../../../manager/navigation";

import { basicDeleteActionField } from "../../../../components/table/fields/common";

import { configureField } from "../../../../core/utils/list";

export const basicColumns = (props) => {
    const { servicesById, vendorsById, loading, filters, resize, hidden } = props;

    if (loading) {
        return [];
    }
    return [
        {
            title: "Job",
            dataIndex: "job",
            ...configureField("j.id", filters, resize, hidden, true, false, false, 200),
            fixed: "left",
            render: (id, record) => <Link to={LAYOUT_MANAGER_JOB_SHOW(record.job?.id)}>J-{record.job?.id}</Link>,
        },
        {
            title: "Job E-ID",
            dataIndex: "job",
            ...configureField("j.eid", filters, resize, hidden, true, false, false, 200),
            fixed: "left",
            render: (id, record) => <>{record.job?.eid}</>,
        },
        {
            title: "Finance Date",
            dataIndex: "job",
            ...configureField("j.financeDate", filters, resize, hidden, true, false, false, 200),
            render: (job) => {
                if (job && job.financeDate) return <>{Moment(job.financeDate).format(DATE_FORMAT)}</>;
            },
        },
        {
            title: "Receivable Code",
            dataIndex: "job",
            ...configureField("j.code", filters, resize, hidden, true, false, false, 200),
            render: (id, record) => <>{record.job?.code}</>,
        },

        {
            title: "Vendor",
            dataIndex: "vendor",
            ...configureField("v.name", filters, resize, hidden, true, false, false, 200),
            render: (vendor) => {
                if (vendor && vendorsById) {
                    return <>{vendorsById[vendor]?.name}</>;
                }
            },
        },
        {
            title: "Service",
            dataIndex: "service",
            ...configureField("s.name", filters, resize, hidden, true, false, false, 200),
            render: (service) => {
                if (service && servicesById) {
                    return <>{servicesById[service]?.name}</>;
                }
            },
        },
        {
            title: "Amount",
            dataIndex: "totalToPayValue",
            ...configureField("t.totalToPayValue", filters, resize, hidden, true, false, true, 200),
            render: (amountValue, record) => {
                return (
                    <AmountText
                        value={Math.round((amountValue - record.balanceVendor) * 10000) / 10000}
                        type={record.totalToPayType}
                    />
                );
            },
        },
    ];
};
